export function downloadFromUrl(url: string): void {
  if (!url) return;

  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
